/// <amd-module name="Wit/Deployment/Constants" />
export namespace DeploymentIntegrationConstants {
    export const LearnMoreDeployments = "https://aka.ms/boardsdeploymentintegration";
}

export const environmentTypeOrderMap: {
    [key: string]: number;
} = {
    ["production"]: 5,
    ["staging"]: 4,
    ["testing"]: 3,
    ["development"]: 2,
    ["unmapped"]: 1
};
